import {FunctionComponent} from "react";
import RemoveConfirmationDialog from "./remove-confirmation";
import ConfirmationDialog from "./confirmation";
import ViewInstallationGuideDialog from "./view-installation-guide";
import DownloadCodeDialog from "./download-code";
import UpsertRegisteredLocationDialog from "./upsert-registered-location";
import CreateSettingsDataForGroupDialog from "./create-settings-data-for-group";
import FieldLogsHistoryDialog from "./field-logs-history";
import ManageOrganizationGroupsDialog from "./manage-employee-groups";


const ApplicationDialogs: FunctionComponent = () => {


    return (
        <>
            <RemoveConfirmationDialog/>
            <ConfirmationDialog/>
            <ViewInstallationGuideDialog/>
            <DownloadCodeDialog/>
            <UpsertRegisteredLocationDialog/>
            <CreateSettingsDataForGroupDialog/>
            <FieldLogsHistoryDialog/>
            <ManageOrganizationGroupsDialog/>
        </>
    );
}


export default ApplicationDialogs;
